import BasePerimeter from '@/kindergarten/perimeters/BasePerimiter';

export default new BasePerimeter({
  purpose: 'project_role',

  can: {
    route() {
      return this.child && (this.isAdmin() || this.isProjectRole());
    },
  },
});



// WEBPACK FOOTER //
// ./src/kindergarten/perimeters/ProjectPerimeter.js